import axios from 'axios';
import { SERVER_URL } from '../../../constants/ClientConfig';
import { BOOKING_DETAILS, IRCTC_BOOKING_ID } from '../../../constants/ActionTypes';
import PDTInfo from '../../../utils/pdtInfo';
import { GET_IRCTC_BOOKING_ID_URL } from '../../../constants/TrainConstants';
import { generateId } from '../../../utils/trainUtils';

export const fetchBookingDetailsAction = (bookingId) => async (dispatch) => {
  const traceId = generateId();
  try {
    const body = {
      bookingId,
      isEncrypted: true,
      ...PDTInfo()
    };
    const headers = {"X-Trace-Id": traceId};
    const bookingDetailsFetchUrl = `${SERVER_URL}/bookingDetails/fetch`;
    const response = await axios.post(bookingDetailsFetchUrl, body,{ headers });
    const data = response && response.data && response.data.data;
    const bookingStatus = response.data.status[0];
    dispatch({
      type: BOOKING_DETAILS,
      payload: {
        bookingDetails: {
          ...data,
          bookingStatus,
        }
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const getIRCTCBookingId = (bookingId) => async (dispatch) => {
  const traceId = generateId();
  try {
    const res = await axios.get(GET_IRCTC_BOOKING_ID_URL, {
      params: {
        mmtId: bookingId || '',
      },
      headers: {
        "X-Trace-Id": traceId
      }
    });    
    const { irctcBookingId = '', wsUserLogin = '' } = res.data;
    dispatch({
      type: IRCTC_BOOKING_ID,
      payload: {
        irctcBookingId: irctcBookingId,
        verifiedUserId: wsUserLogin,
      },
    });
  } catch (error) {
    console.error(error);
  }
};
